import { Component, OnInit } from '@angular/core';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';

@Component({
  selector: 'app-publicacoes-diarias',
  templateUrl: './publicacoes-diarias.component.html',
})
export class RelatorioPublicacoesDiariasComponent implements OnInit{
  dataHoje: string;
  public listaArea: Area[] = [];

  constructor(
    private areaService: AreaService
  ) { }
  ngOnInit() {
    this.areaService.obterLista("", 1).toPromise()
    .then(data => {
          this.listaArea = data;
        },
        (erro) => {
          console.error('Erro ao obter a lista de áreas:', erro);
        }
    );
  }
}
